import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'credentials' },
    { value: 2, label: 'identifiers' },
    { value: 3, label: 'status' },
    { value: 4, label: 'enrolments' },
    { value: 5, label: 'unenrolments' },
  ],
});
